import { Button, Chip, Group, Popover, Text } from 'components'
import { useArcTranslation } from 'hooks'
import { TAG_POPOVER_WIDTH } from '../constants'
import type { SanityTag } from '../interfaces'

interface TagFilterChipsProps {
  visibleTags: SanityTag[]
  overflowTags: SanityTag[]
  selectedTags: string[]
  onChange: (value: string[]) => void
}

// Tag filter row: inline chips plus a "+N more" popover for the overflow.
export const TagFilterChips = ({ visibleTags, overflowTags, selectedTags, onChange }: TagFilterChipsProps) => {
  const { t } = useArcTranslation()

  return (
    <Chip.Group multiple value={selectedTags} onChange={onChange}>
      <Group spacing='xs'>
        <Text size='sm' color='dimmed'>
          {t('resource_center.filter_by_tags')}
        </Text>
        {visibleTags.map(tag => (
          <Chip key={tag._id} value={tag._id} size='xs' radius='xl' variant='outline'>
            {tag.title}
          </Chip>
        ))}
        {overflowTags.length > 0 ? (
          <Popover position='bottom-start' shadow='md' width={TAG_POPOVER_WIDTH} withinPortal>
            <Popover.Target>
              <Button variant='subtle' compact size='xs' radius='xl'>
                {t('resource_center.more_tags', { total: overflowTags.length })}
              </Button>
            </Popover.Target>
            <Popover.Dropdown>
              <Group spacing='xs'>
                {overflowTags.map(tag => (
                  <Chip key={tag._id} value={tag._id} size='xs' radius='xl' variant='outline'>
                    {tag.title}
                  </Chip>
                ))}
              </Group>
            </Popover.Dropdown>
          </Popover>
        ) : null}
      </Group>
    </Chip.Group>
  )
}
